import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartMultiBar } from 'src/common/charts';
import { fetchMilitaryReports } from 'actions/Report/Contact/Military';
import _ from 'lodash';
import { genderPartitions } from '../../utils/partitions';
import { genderColors } from '../../utils/colors';
import sortByTitleNoResponseLast from '../../utils/sortByTitleNoResponseLast';

export default class AffiliationByGender extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      affiliationByGender: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.filters, nextProps.filters)) {
      this.fetchData(nextProps.filters);
    }
  }

  fetchData(filters) {
    const { scope, id } = this.props;

    fetchMilitaryReports(scope, id, 'affiliation/by-gender', { partitions: genderPartitions(), ...filters })
      .then((response) => {
        const data = _.get(response, 'data', {});
        data.values = sortByTitleNoResponseLast(data.values);
        this.setState({
          affiliationByGender: data,
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('affiliationByGender');
      });
  }

  render() {
    if (_.isEmpty(this.state.affiliationByGender)) {
      return null;
    }
    return (
      <ChartMultiBar
        data={this.state.affiliationByGender}
        x={(d) => d.title}
        y={(d) => d.total}
        title={this.state.title}
        margin={{ left: 60, top: 60, bottom: 60 }}
        showValues
        showYAxis
        showLegend
        stacked
        valueFormat="d"
        useInteractiveGuideline={false}
        colors={genderColors}
        xLabel="Affiliation"
        colWidths={{
          x: '270px',
        }}
      />
    );
  }
}

AffiliationByGender.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
